<template>
  <div class="fullname">
    <div class="fullname_top">
      <van-icon
        style="position: absolute; left: 10px"
        size="25"
        name="arrow-left"
        @click="to()"
      />
      <div class="my">{{ $route.query.title }}</div>
      <div class="determine" @click="setSave">
        {{ status == 0 ? "审核中" : "确定" }}
      </div>
    </div>
    <div id="periodicalEditor">
      <Editor class="editor-box" v-model="value" :init="editorInit"></Editor>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import tinymce from "tinymce/tinymce";
import Editor from "@tinymce/tinymce-vue";
import "tinymce/themes/silver/theme";
import "tinymce/icons/default/icons.min.js"; // 引入富文本编辑器图标
import "tinymce/plugins/image";
import "tinymce/plugins/link";
import "tinymce/plugins/media";
import "tinymce/plugins/table";
import "tinymce/plugins/lists";
import "tinymce/plugins/wordcount";
import "tinymce/plugins/hr";
import "tinymce/plugins/paste";
import "tinymce/plugins/autoresize";
import "@/assets/tinymce/plugins/indent2em";
import "@/assets/tinymce/plugins/lineheight";
import "@/assets/tinymce/plugins/formatpainter";
export default {
  name: "PeriodicalEdit",
  components: {
    Editor,
  },
  data() {
    return {
      value: "",
      status: 1,
      editorInit: {
        // 富文本配置
        selector: `#periodicalEditor`,
        language_url: "/admin/tinymce/zh_CN.js", // 中文语言包路径
        language: "zh_CN",
        skin_url: "/admin/tinymce/skins/ui/oxide", // 富文本css图标路径
        statusbar: false, // 隐藏编辑器下方内容
        menubar: false, // 隐藏菜单栏
        placeholder: "请输入内容", // 占位内容
        content_style: "img,video {max-width:100%;}",
        // content_style:
        //   "body, button, input, select, textarea {font-family: 'Microsoft YaHei';font-size: 18px;} p {margin: 0;}",
        font_formats:
          "微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;宋体=simsun,serif", // 字体
        fontsize_formats: "11px 12px 14px 16px 18px 24px 36px 48px", // 字号
        plugins: "autoresize", //   "link lists image table wordcount media indent2em hr lineheight formatpainter  paste", //  autoresize 富文本插件 paste
        // height: '100%',
        // toolbar: "paste undo redo removeformat formatpainter fontsizeselect fontselect formatselect bold italic alignleft aligncenter alignright alignjustify | lineheight indent2em bullist numlist | link image media | hr blockquote italic strikethrough underline backcolor forecolor table",
        toolbar: false, // 工具栏 paste
        // file_picker_callback: this.fileUplode, // 调用上传文件方法
        paste_postprocess: function (plugin, args) {
          args.node.childNodes.forEach((item) => {
            if (item.innerHTML) {
              item.innerHTML = item.innerHTML.replace(/^\s*/g, "");
              item.style = "text-indent: 2em;line-height: 2;font-size: 18px;";
            }
          });
          nodesRecursion(args.node.childNodes);
        },
        setup: function (editor) {
          // 设置富文本编辑框内容固定样式
          editor.on("init", function () {
            editor.execCommand("fontName", false, "Microsoft YaHei");
            editor.execCommand("fontSize", false, "18px");
            editor.execCommand("lineHeight", false, "2");
          });
        },
      },
    };
  },
  created() {
    this.getUserDetails();
  },
  methods: {
    // 循环遍历出复制到富文本的内容 选出img 和 a标签
    nodesRecursion(arr) {
      arr.forEach((item) => {
        if (item.nodeName == "A") {
          var newNode = document.createElement("span"); // 创建一个元素
          newNode.textContent = item.textContent;
          item.parentNode.replaceChild(newNode, item); //  获取子元素原来的父元素并将新父元素代替子元素
        } else if (item.nodeName == "IMG") {
          var parent = document.createElement("div"); //  新建一个父元素
          parent.style = "text-align: center"; // 设置父元素样式
          item.parentNode.replaceChild(parent, item); //  获取子元素原来的父元素并将新父元素代替子元素
          parent.appendChild(item); // 将元素添加到新加的父元素里
        } else if (item.childNodes && item.childNodes.length > 0) {
          this.nodesRecursion(item.childNodes);
        } else {
          return;
        }
      });
    },
    to() {
      window.history.go(-1);
    },
    // 获取基本信息
    async getUserDetails() {
      const res = await this.$apis.userServe.getMaDetails();
      if (this.$route.query.key === "periodicalIntro" && res.data && res.data.intro) {
        this.value = res.data.intro.jsonDataObj.periodicalIntro;
        this.status = res.data.intro.status;
      } else if (this.$route.query.key === "notice" && res.data && res.data.notice) {
        this.value = res.data.notice.jsonDataObj.notice;
        this.status = res.data.notice.status;
      }
    },
    async setSave() {
      if (this.status == 0) return;
      let res = {};
      console.log(this.$route.query,'this.$route.query.key');
      
      if (this.$route.query.key === "periodicalIntro") {
        res = await this.$apis.userServe.setPeriodicalIntro({
          periodicalIntro: this.value,
        });
      } else if (this.$route.query.key === "notice") {
        res = await this.$apis.userServe.setPeriodicalNotice({
          notice: this.value,
        });
      }
      if (res.resultCode === "200") {
        Toast("提交成功");
        window.history.go(-1);
      } else {
        Toast(res.resultDesc);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.fullname {
  width: 100vw;
  min-height: 100vh;
  overflow: hidden;
  background: #f5f5f5;

  .fullname_top {
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    line-height: 44px;
    align-content: center;
    position: relative;

    .my {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      background: #fff;
      text-align: center;
    }

    .determine {
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      position: absolute;
      right: 15px;
    }
  }
}
#periodicalEditor {
  margin: 12px auto;
  width: 94%;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  &::v-deep .tox {
    border: none;
  }
  .editor-box {
    border: none;
  }
}
</style>
